export const topButtons = {
    height: "40vh",
    lineHeight: "40vh",
    color: "yellow",
    fontWeight: "bold",
    fontSize: "1.5rem",
    cursor: "pointer"
};

export const topButtonsText = {
    display: "inline-block",
    verticalAlign: "middle",
    lineHeight: "30px" /* <-- adjust this */
};

export const callOutButton = {
    color: "yellow",
    fontWeight: "bold",
    fontSize: "1.5rem",
    cursor: "pointer"
};
